import React from 'react';

const MaxCharacterCount = ({characterCount, maxNotesCharacters}) => 
    <div style={{color: "dimgrey"}}>
        {characterCount}/{maxNotesCharacters}
    </div>

export default MaxCharacterCount;